function initDropdownMenuForm() {
  /**
   * Listens for dropdown menu interactions like
   * clicking checkboxes, labels & etc. and
   * prevents dropdown from closing
   */
  $('.dropdown-menu').on('click', function (e) {
    if ($(this).hasClass('dropdown-menu-form')) {
      e.stopPropagation();
    }
  });
}

function listenForToggleTriggerClick() {
  $('body').on('click', '.toggle-trigger', function () {
    if ($(this).hasClass('disabled')) {
      return;
    }

    var target = $(this).attr('data-target');
    $('#' + target).toggleClass('hidden');
  });
}

function applyFadeOutToFlashMessages() {
  var FADEIN_DELAY = 250;
  var FADEOUT_DELAY = 2000;
  $('.flash.alert').each(function (index, el) {
    $(el).delay(FADEIN_DELAY).fadeIn('normal', function () {
      $(this).delay(FADEOUT_DELAY).fadeOut();
    });
  });
}

export { initDropdownMenuForm, listenForToggleTriggerClick, applyFadeOutToFlashMessages };